/**
 *
 * Usage:
 * <input type="text" autofocus>
 */
(function (module) {
    'use strict';
    module.directive('autofocus', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            link: function ($scope, $element) {
                $timeout(function () {
                    $element[0].focus();
                });
            }
        };
    }]);
}(angular.module('emarket.commons')));